export default "__VITE_ASSET__BPGbS3ID__"